import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { X, Scales, ArrowRight } from "@phosphor-icons/react";
import { compare, useLocalList } from "@/lib/storage";
import { api, fmtPrice, resolveImage } from "@/lib/api";

export default function CompareBar() {
  const ids = useLocalList(compare);
  const [items, setItems] = useState([]);
  useEffect(() => {
    if (!ids.length) { setItems([]); return; }
    (async () => {
      const rs = await Promise.all(ids.map((id) => api.get(`/listings/${id}`).then((r) => r.data).catch(() => null)));
      setItems(rs.filter(Boolean));
    })();
  }, [ids.join(",")]);
  if (!ids.length) return null;
  return (
    <div
      data-testid="compare-bar"
      className="fixed left-1/2 -translate-x-1/2 bottom-6 z-30 w-[calc(100%-2rem)] max-w-3xl bg-[#ffffff] border border-[#001588]/30 shadow-2xl px-4 py-3 flex items-center gap-3"
    >
      <Scales size={18} weight="fill" className="text-[#001588]" />
      <div className="flex-1 flex items-center gap-2 overflow-x-auto">
        {items.map((p) => (
          <div key={p.id} className="flex items-center gap-2 bg-white border border-neutral-200 px-2 py-1 shrink-0">
            {p.images?.[0] && <img src={resolveImage(p.images[0])} alt={p.title || "Compared property"} className="w-8 h-8 object-cover" />}
            <div className="text-xs">
              <div className="text-white truncate max-w-[130px]">{p.title}</div>
              <div className="text-neutral-500">{fmtPrice(p.price, p.currency)}</div>
            </div>
            <button onClick={() => compare.remove(p.id)} className="text-neutral-500 hover:text-white" data-testid={`compare-remove-${p.id}`}>
              <X size={12} />
            </button>
          </div>
        ))}
      </div>
      <Link
        to="/compare" data-testid="compare-open"
        className="flex items-center gap-2 bg-[#001588] text-white px-4 py-2 text-sm tracking-wide hover:bg-white transition-colors"
      >
        Compare {items.length} <ArrowRight size={14} />
      </Link>
      <button onClick={() => compare.clear()} className="text-neutral-400 hover:text-white text-xs" data-testid="compare-clear">Clear</button>
    </div>
  );
}
